/**
 * Keys that are excluded from CMCD event mode.
 *
 * @group CMCD
 *
 * @beta
 */
export type CmcdEventExcludedKeys =
	| 'bs'
	| 'bsd'
	| 'cmsdd'
	| 'cmsds'
	| 'd'
	| 'dl'
	| 'nor'
	| 'ot'
	| 'rc'
	| 'rtp'
	| 'smrt'
	| 'su'
	| 'ttfbb'
	| 'ttlb'
	| 'url';
